import * as React from "react"

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} {...props}>
    <g data-name="camera icon">
      <g data-name="Path 196" fill="#fff">
        <path d="M11 21.5C5.21 21.5.5 16.79.5 11S5.21.5 11 .5 21.5 5.21 21.5 11 16.79 21.5 11 21.5Z" />
        <path
          d="M11 1C5.486 1 1 5.486 1 11s4.486 10 10 10 10-4.486 10-10S16.514 1 11 1m0-1c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0Z"
          fill="#363636"
        />
      </g>
      <g data-name="211634_camera_icon" fill="#363636">
        <path
          data-name="Path 194"
          d="M16.547 7.423h-2.214l-1.326-1.339L13 6.078l-.007-.007a1.073 1.073 0 0 0-.767-.321H9.47a1.085 1.085 0 0 0-.807.358l-1.3 1.313H5.1A1.09 1.09 0 0 0 4 8.513v6.631a1.1 1.1 0 0 0 1.1 1.106h11.447a1.106 1.106 0 0 0 1.1-1.106V8.513a1.092 1.092 0 0 0-1.1-1.09Zm-5.722 7.17a3.038 3.038 0 1 1 3.032-3.038 3.041 3.041 0 0 1-3.032 3.038Zm5.516-5.414a.463.463 0 1 1 .459-.463.461.461 0 0 1-.459.463Z"
        />
        <path
          data-name="Path 195"
          d="M10.825 9.258a2.3 2.3 0 1 0 2.29 2.3 2.292 2.292 0 0 0-2.29-2.3Z"
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent